import { FETCH_DATA_CENTER, FETCH_DATA_CENTER_SUCCESS, FETCH_DATA_SEARCH_QUERY, FETCH_DATA_SEARCH_QUERY_PAST } from "constants/ActionTypes";

export const fetch_datacenter_details_action = payload => ({
  type: FETCH_DATA_CENTER,
  payload,
});

export const fetch_datacenter_details_success = payload => ({
  type: FETCH_DATA_CENTER_SUCCESS,
  payload,
});

export const fetch_search_query_action = payload => {
  return {
    type: FETCH_DATA_SEARCH_QUERY,
    payload,
  };
};
export const fetch_search_query_action_past = payload => {
  return {
    type: FETCH_DATA_SEARCH_QUERY_PAST,
    payload,
  };
};
